import { ActivatedRouteSnapshot } from '@angular/router';

export function buildRoutePath(segments: string[]): string {
  const joined = segments.join('/').replaceAll('//', '/');
  const fullPath = joined.startsWith('/') ? joined : `/${joined}`;
  return fullPath.length > 1 ? fullPath.replace(/\/$/, '') : fullPath;
}

export function getFullRoutePath(route: ActivatedRouteSnapshot): string {
  return buildRoutePath(route.pathFromRoot.map(r => r.routeConfig?.path ?? ''));
}
